"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const useOsmosysContext_1 = require("../../hooks/useOsmosysContext");
exports.OnlyWhenWorkspaceSetting = (_a) => {
    var { children, fallback } = _a, props = tslib_1.__rest(_a, ["children", "fallback"]);
    fallback = react_1.default.createElement(react_1.default.Fragment, null, fallback) || react_1.default.createElement(react_1.default.Fragment, null, null);
    const { currentWorkspace } = useOsmosysContext_1.useOsmosysContext();
    if (!currentWorkspace) {
        return fallback;
    }
    const workspaceHasAccess = Object.entries(props).every(([propKey, propValue]) => {
        return currentWorkspace[propKey] === propValue;
    });
    if (workspaceHasAccess) {
        return react_1.default.createElement(react_1.default.Fragment, null, children);
    }
    return fallback;
};
//# sourceMappingURL=OnlyWhenWorkspaceSetting.js.map